import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

type ClassValue =
  | string
  | number
  | boolean
  | undefined
  | null
  | ClassValue[]
  | { [key: string]: boolean | undefined | null };

export function cn(...inputs: ClassValue[]): string {
  return twMerge(classNames(inputs));
}
